import React from 'react';
import { omit } from 'ramda';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Modal from 'sharedComponents/Modal';
import { Box, Typography, IconButton } from '@material-ui/core';
import Icon from 'sharedComponents/Icon';
import useApp from 'reducers/hooks/useApp';

import SteppedBuyerRegistrationForm from 'sharedComponents/SteppedBuyerRegistrationForm';

import useStyles from './useStyles';

const BuyerRegistration = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { signUp } = useApp();
  const { onFinish, onClose } = props;

  const handleSubmit = async (values, { setErrors }) => {
    const attrs = omit('passwordConfirmation', values);
    try {
      await signUp({ ...attrs, userType: 'buyer' });
      onFinish();
    } catch (error) {
      setErrors({ email: error });
    }
  };

  return (
    <Modal onClose={onClose} closeButton>
      <Box width="100%" display="flex" flexDirection="row-reverse">
        <IconButton onClick={onClose}>
          <Icon name="close" />
        </IconButton>
      </Box>
      <Box width="100%" display="flex" flexDirection="column" alignItems="center">
        <Icon name="logo" width="100" />
        <Typography className={classes.header} variant="h1">
          {t('components.Quiz.BuyerRegistration.header')}
        </Typography>
      </Box>
      <SteppedBuyerRegistrationForm onSubmit={handleSubmit} />
    </Modal>
  );
};

BuyerRegistration.propTypes = {
  onFinish: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BuyerRegistration;



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/BuyerRegistration/BuyerRegistration.js